// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c1fe85f","239":"71759555","455":"7aef96c2"}[chunkId] + ".chunk.js";
};